import { Socket, io } from 'socket.io-client';

export const SOCKET: Socket = io(process.env.REACT_APP_BASE_URL!, {
  autoConnect: false,
  transports: ['websocket', 'polling'],
});

export const connect = () => {
  return SOCKET.connect();
};

export const disconnect = () => {
  return SOCKET.disconnect();
};

const socketActionCreators = (dispatch: <T>(options: any) => T) =>
  Object.assign(
    {},
    {
      connect,
      disconnect,
      SOCKET,
    },
  );

export default socketActionCreators;
